




















import VueOptions from '@utils/VueOptions'
import FormFieldSelect from '@ui/FormBuilder/FormFields/FormFieldSelect'

settings =
  name: 'FormFieldTeamSelect'

  vue:
    props: ['value', 'errors', 'placeholder', 'limit', 'options', 'context']

    components: {
      FormFieldSelect,
    }

    data: ->
      value_: @value || []
      selectedTeamId: null

    computed:
      member: -> @$store.member
      supplierId: ->
        @context?.supplierId || @member.supplier.id

      teams: -> @options || []

      selectedTeams: ->
        teams = (@teams || [])
        for teamId in @value_
          continue if teamId is @supplierId
          teams.find((t) => t.id is teamId)

      optionsForTeamSelect: ->
        for team in (@teams || [])
          continue if team.id in @value_
          {
            value: team.id
            label: team.name
          }

    methods:
      hiAddTeam: (teamId) ->
        return if @value_.includes teamId
        @value_.push teamId
        @inputChanged()

      hiRemoveTeam: (team) ->
        @value_ = @value_.filter((t) => t isnt team.id)
        @inputChanged()

      inputChanged: ->
        @$emit 'input', @value_

    watch:
      teams: ->
        @hiAddTeam(@teams[0].id) if @teams.length is 1 and @selectedTeams.length is 0

export default VueOptions.vue settings
